// TODO: drop view constants on FG ditto_uim_-_load_view_type_configuration removal, they should be available in view specific packages already
/** @deprecated */
export const GIC_VIEW_TYPE = 'GIC';
/** @deprecated */
export const ISSUE_VIEW_VIEW_TYPE = 'IssueView';
/** @deprecated */
export const ISSUE_TRANSITION_VIEW_TYPE = 'IssueTransition';
